import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sxProps?: SxProps
  [prop: string]: any
}

export const ShareOutlineIcon = ({ sxProps, ...props }: Props) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path d="M11.667 4.167V7.5c-5.834.833-8.334 5-9.167 9.167 2.083-2.917 5-4.25 9.167-4.25v3.416L17.5 10l-5.833-5.833Zm1.666 4.025L15.142 10l-1.809 1.808V10.75h-1.666c-1.725 0-3.275.317-4.717.792 1.167-1.159 2.667-2.067 4.95-2.375l1.433-.225v-.75Z" />
  </SvgIcon>
)

ShareOutlineIcon.defaultProps = {
  sxProps: null,
}
